import { type ReactNode } from 'react'
import { NavLink } from 'react-router-dom'
import styles from './Tabs.module.css'

type TabItem = {
  icon?: ReactNode
  label: string
  to: string
}

type TabsProps = {
  ariaLabel: string
  className?: string
  items: TabItem[]
}

export const Tabs = ({ ariaLabel, className, items }: TabsProps) => (
  <div className={[styles.tabs, className].filter(Boolean).join(' ')} role="tablist" aria-label={ariaLabel}>
    {items.map((item) => (
      <NavLink
        className={({ isActive }) => [styles.tab, isActive ? styles.active : ''].filter(Boolean).join(' ')}
        end
        key={item.to}
        role="tab"
        to={item.to}
      >
        {item.icon}
        <span>{item.label}</span>
      </NavLink>
    ))}
  </div>
)
